// Runtime constants of the PWA. The API lives behind /api on the same origin (dev proxy, nginx in
// prod); media objects are read directly from the bucket (docs/project.md §3).
export const API_BASE = '/api';
export const MEDIA_BASE_URL: string = __MEDIA_BASE_URL__.replace(/\/+$/, '');
export const APP_RELEASE: string = __APP_RELEASE__;
export const SENTRY_DSN: string = __SENTRY_DSN__;
// Product analytics (OpenPanel); an empty client id turns it off (dev, the local stack)
export const ANALYTICS_API_URL: string = __OPENPANEL_API_URL__.replace(/\/+$/, '');
export const ANALYTICS_CLIENT_ID: string = __OPENPANEL_CLIENT_ID__;
// Runtime cache of media in the service worker; app code prefetches into the same cache
export const MEDIA_CACHE_NAME = 'solungo-media-v1';

export function mediaUrl(key: string): string {
  return `${MEDIA_BASE_URL}/${key}`;
}
